import { useContext, useEffect, useRef } from "react";
import { Outlet, useNavigate, Navigate } from "react-router-dom";
import UserContext from "user/UserContext";
import { AUTH_STATUS } from "constants/auth";
import log from "loglevel";
import { toast } from "sonner";

export const ProtectedRoute = () => {
  const { authStatus } = useContext(UserContext);
  const navigate = useNavigate();
  const msgShownRef = useRef(false);
  
  useEffect(() => {
    if (authStatus === AUTH_STATUS.UNAUTHENTICATED) {
      if (!window.__skipProtectedMsg && !msgShownRef.current) {
        toast.error('로그인이 필요합니다');
        msgShownRef.current = true;
      }
      window.__skipProtectedMsg = false;

      navigate('/', { replace: true, state: { reason: AUTH_STATUS.UNAUTHENTICATED }});
    }
  }, [authStatus]);
  
  if (authStatus === AUTH_STATUS.CHECKING) {
    log.debug('PROTECTED_ROUTE authStatus=checking');
    return null;
  }

  if (authStatus === AUTH_STATUS.UNAUTHENTICATED) {
    log.debug('PROTECTED_ROUTE redirect to main page');
    return <Navigate to="/" replace />
  }

  return <Outlet />;
};

// export const ProtectedRoute = () => {
//   const { authStatus } = useContext(UserContext);
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (authStatus === AUTH_STATUS.UNAUTHENTICATED) {
//       log.debug('PROTECTED_ROUTE redirect to main page');
//       navigate('/', { replace: true, state: { reason: AUTH_STATUS.UNAUTHENTICATED }});
//     }
//   }, [authStatus, navigate]);
  
//   if (authStatus === AUTH_STATUS.CHECKING) {
//     log.debug('PROTECTED_ROUTE authStatus=checking');
//     return null;
//   }

//   if (authStatus === AUTH_STATUS.UNAUTHENTICATED) {
//     log.debug('PROTECTED_ROUTE authStatus=unauthenticated');
//     return null;
//   }
  
//   return <Outlet />;
// };